export default __webpack_public_path__ + "static/media/3cha.0e1af4e1.svg";